// extracted by mini-css-extract-plugin
export var rightContainer = "styles-module__rightContainer___RhQ3K";